import React, { Component } from 'react';
import * as Types from '../types/index';
import PropTypes from 'prop-types';
import {formatCurrency} from '../utils/currency';
import QtySelect from './QtySelect';
import StatusLabel from './StatusLabel';
import StatusLabelLink from './StatusLabelLink';
import {formatDate} from '../utils/dates';

class Product extends Component {
  constructor(props) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.handleQtyChange = this.handleQtyChange.bind(this);
    this.handleAddToCart = this.handleAddToCart.bind(this);
  }

  handleQtyChange(qty) {
    return new Promise(resolve => {
      this.props.onQtyChange(this.props.product, qty).then(resolve);
    });
  }

  handleAddToCart() {
    // default qty to "1" if not selected
    if (this.props.qty === '') {
      this.handleQtyChange('1').then(this.props.onAddToCart);
    } else {
      this.props.onAddToCart();
    }
  }

  render () {
    const product = this.props.product;
    return(
      <div itemprop="itemListElement" itemscope itemtype="http://schema.org/Product" className={`product-row my-products__row ${(product.isPurchased && product.isSaved) ? '-purchased' : ''}`}>
        <link itemprop="sku" content={product.id}/>
        <link itemProp="category" content={product.productSubcategoryName}/>

        { product.schemaBrand && <link itemProp="brand" content={product.schemaBrand}/> }
        { product.gtin && <link itemProp="gtin12" content={product.gtin}/> }
        { product.mpn && <link itemProp="mpn" content={product.mpn}/> }
        { product.schemaTitle && <link itemProp="name" content={product.schemaTitle}/> }
        { product.schemaDescription && <link itemProp="description" content={product.schemaDescription}/> }
        { product.colorName && <link itemProp="color" content={product.colorName}/> }
        { product.image && <link itemProp="image" content={`https://www.sundatasupply.com/uploads/products/${product.image}`}/> }

        <div className="columns small-12 medium-8 large-9">
          <div className="product-row__image">
            <span>
              <a href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`}>
                <img src={`${ROOT_URL}/uploads/products/${product.image}`} />
              </a>
            </span>
          </div>
          <div className="product-row__details">
            <p>
              <span>
                {
                  !this.props.isInMyProducts &&
                  (
                    product.isSaved
                      ? <a className="button float-right minimal -gray" onClick={() => this.props.onRemoveFromMyProducts(product.id)}>Remove from Your Products</a>
                      : <a className="button float-right minimal -gray" onClick={() => this.props.onAddToMyProducts(product.id)}>Add to Your Products</a>
                  )
                }
              </span>
              <small>Item #: {product.code}</small>
            </p>
            <p className="product-row__title">
              <a itemprop="url" href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`} dangerouslySetInnerHTML={{__html: product.name}}/>
            </p>
            <p className="product-row__desc" dangerouslySetInnerHTML={{__html: product.shortDesc}}/>
            <p><StatusLabel remainingStock={product.remainingStock}
                            isDiscontinued={product.isDiscontinued}
                            isComingSoon={product.isComingSoon}
                            callForPricing={product.callForPricing}
                            specialShipDate={product.specialShipDate}
                            specialShipDays={product.specialShipDays}
                            backorderShipDate={product.backorderShipDate}
                            backorderShipDays={product.backorderShipDays}/></p>
          </div>
        </div>
        <div className="columns small-8 medium-4 large-3 product-row__right" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
          <link itemProp="priceCurrency" content="USD"/>
          {
            [1,2,3,4].includes(product.conditionId) &&
            (
              <link itemProp="itemCondition" content={product.conditionId == 4 ? 'RefurbishedCondition' : 'NewCondition'}/>
            )
          }
          <link itemProp="url" content={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`}/>
          <span itemProp="deliveryLeadTime" itemScope itemType="https://schema.org/QuantitativeValue">
            <link itemProp="maxValue" content={product.itemShipDays}/>
          </span>
          <StatusLabelLink remainingStock={product.remainingStock}
                       isDiscontinued={product.isDiscontinued}
                       isComingSoon={product.isComingSoon}
                       specialShipDate={product.specialShipDate}
                       specialShipDays={product.specialShipDays}
                       backorderShipDate={product.backorderShipDate}
                       backorderShipDays={product.backorderShipDays}/>

          {
            !product.callForPricing &&
            <p className={'product-row__price' + (product.isCustomerPrice ? ' -is-customer-price' : '')} itemprop="priceSpecification" itemscope itemtype="https://schema.org/PriceSpecification">{formatCurrency(product.salePrice || product.price)}
              <span itemprop="price" content={product.salePrice || product.price}>
                {product.salePrice && <del className="product-row__price__old">{formatCurrency(product.price)}</del>}
              </span>
              <link itemProp="priceCurrency" content="USD"/>
            </p>
          }

          {
            !product.callForPricing && product.savePrice.length > 1 &&
            <p className="product-row__save-price">{product.savePrice}</p>
          }

          {
            product.remainingStock > 0 && !product.isDiscontinued && !product.isComingSoon && !product.callForPricing &&
            <div className="input-group">
              <QtySelect className="input-group-field" value={this.props.qty} onChange={this.handleQtyChange} min={1}/>
              <div className="input-group-button">
                <a className="button primary small" onClick={this.handleAddToCart}>Add to cart</a>
              </div>
            </div>
          }

          {
            this.props.isInMyProducts &&
            <a className="button small -gray" href={`${ROOT_URL}/delete_myproduct.php?id=${product.id}`}>Remove from list</a>
          }

          {
            !this.props.isInMyProducts && (product.salePrice || product.price) > 50 &&
            <p className="product-row__free-shipping">Free Shipping on this item</p>
          }
        </div>
        <div className="clearfix"/>
        {
          !this.props.isInMyProducts && !!product.isPurchased && !!product.isSaved &&
          <div className="product-row__purchased">
            <a className="product-row__purchased__close" onClick={() => this.props.onRemoveFromMyProducts(product.id)}>&times; Dismiss</a>
            You ordered this item last on {formatDate(product.lastOrderDate)},
            on order <a href={`${ROOT_URL}/vieworder.php?oid=${product.lastOrderId}`}>#{product.lastOrderNumber}</a>
          </div>
        }
      </div>
    );
  }
}

Product.propTypes = {
  product: Types.product.isRequired,
  qty: PropTypes.string,
  isInMyProducts: PropTypes.bool,
  onAddToMyProducts: PropTypes.func,
  onRemoveFromMyProducts: PropTypes.func,
  onQtyChange: PropTypes.func,
  onAddToCart: PropTypes.func,
};

export default Product;
